import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import {
  createClient,
  ContentfulClientApi,
  EntryCollection,
  Entry,
} from 'contentful';
import { PageId } from '../utilities/pageids.enum';
import { isPlatformBrowser } from '@angular/common';
import { CoreService } from './core.service';

@Injectable({
  providedIn: 'root',
})
export class ContentfulService {
  private cdaClient: ContentfulClientApi<any>;

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private core: CoreService
  ) {
    this.cdaClient = createClient({
      space: PageId.space,
      accessToken: PageId.accessToken,
      environment: PageId.environment,
    });
  }

  async getEntries<T extends import('contentful').EntrySkeletonType = import('contentful').EntrySkeletonType>(payload: any): Promise<EntryCollection<T>> {
    const dataPromise = this.cdaClient.getEntries<T>(payload);
    const isServer = !isPlatformBrowser(this.platformId);

    if (isServer) {
      return this.core.waitFor(dataPromise);
    } else {
      return dataPromise;
    }
  }

  async getEntry<T extends import('contentful').EntrySkeletonType = import('contentful').EntrySkeletonType>(entryId: string): Promise<Entry<T>> {
    const isServer = !isPlatformBrowser(this.platformId);
    const dataPromise = this.cdaClient.getEntry<T>(entryId);

    if (isServer) {
      return this.core.waitFor(dataPromise);
    } else {
      return dataPromise;
    }
  }
}
